class FacebookCAPI {
  static logEvent = (name, data = null) => {
    (window as any).fbq('track', name, data);
  };
}

export default FacebookCAPI;
